/**
 * Plan utilities for feature gating
 * 
 * IMPORTANT: Always use these helpers for feature gating instead of checking
 * user.subscription_plan directly. Family members may have subscription_plan="free"
 * but effective_plan="family" (inherited from owner).
 */

/**
 * Get the plan to use for feature gating and UI display
 * Returns effective_plan if available (handles family member inheritance),
 * otherwise falls back to subscription_plan
 */
export const getPlanForFeatures = (user) =>
  user?.effective_plan ?? user?.subscription_plan ?? "free";

/**
 * Check if user can access AI features (Plus or Family plan)
 */
export const canUseAI = (user) => {
  const plan = getPlanForFeatures(user);
  return plan === "plus" || plan === "family";
};

/**
 * Check if user has any paid plan (not free)
 */
export const isPaidPlan = (user) => {
  const plan = getPlanForFeatures(user);
  return plan !== "free";
};

/**
 * Check if user is a family member (gets access via family owner)
 */
export const isFamilyMember = (user) =>
  user?.family_role === "member" && user?.family_group_id;
